import { GET } from '../utils/crud'

export const listSupportOrganisms = async () => await GET('support-organisms')
